import {
  ActionType,
  MiniStressTypePDFDownloadResponse,
  IMiniStressTypeDownloadPdfData,
} from "models/stressCheck/miniStressTypeDownloadPdf";

export const miniStressPdfDownloadAction = (
  payload: IMiniStressTypeDownloadPdfData
) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: MiniStressTypePDFDownloadResponse
) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA,
  };
};
